/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";
import "./WelcomePage.scss";
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link, Grid, Button } from '@mui/material';
import { ImageComponent, LoadingComponent, CommonBannerComponent} from "../../components";
import HandleFormUtil from '../../common/utilities/HandleFormUtil';
import urlParams from '../../QueryParameters';
import '../../common/theme/UserFlowPage.scss';
import appSettings from '../../appSettings';
import logo from './../../common/assets/img/agent-account-create-image.png';
import { fetchVerifyUserEncrypt } from '../../common/services/proxyServices';

const WelcomePage = (props) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const username = queryParams.get('username');
    const [agentType, setAgentType] = useState({});
    const [loading, setLoading] = useState(true);
    const [encryptedUserData, setEncryptedUserData] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const { history,  showBannerType, setShowBannerType, } = HandleFormUtil();
    const errorCodesToIgnore = ['E100A', 'E200'];

    let IdValue = urlParams.get("id");

    const baseAccountObject = {
        title: 'Create an account: Before you start',
        subtitle: 'Welcome!',
        copy: 'Creating an AMsuite+ account is the key that opens your one-stop shop. It lets you manage your book, serve clients, and stay up to date—all in one place.',
        header: "Let's get started",
    };

    const newAgent = {
        ...baseAccountObject,
        header: "Let's get started",
        requirements: [
            "Your username—listed in your Welcome email or your existing AMIG username if you already have one",
            "Your phone—to verify your identity",
            "Your email—it’ll be your Login ID to access your AMsuite+ account; also used for verification",
            "If you’re a licensed agent, you may also be asked for your National Producer Number (NPN)"
        ],
        redirectLink: '/userFlow'
    };

    const capLegacy = {
        ...baseAccountObject,
        requirements: ["First, log in through modernLINK using your current username and password."],
        redirectLink: '/userFlow'
    };

    const nonCapLegacy = {
        ...baseAccountObject,
        requirements: [
            "First, log in through modernLINK using your current username and password. If you have more than one, start with the one you use the most. You can add more usernames once you've created your account; use the \"I want to...\" dropdown menu at the top of any page."
        ],
		redirectLink: '/userFlow'
    };

    const originLegacy = {
        title: "Create an account",
        subtitle: `You're on your way, ${username || "User"}!`,
        copy: "Now that we know who you are, the rest of your account setup will be a breeze",
        header: "What you'll need next:",
        requirements: [
            "Your email - it'll be your Login ID to access your AMsuite+ account, also used for verification",
            "Your phone - to verify your identity"
        ],
		redirectLink: ''
    };

    const handleNavigation = (url) => {
        window.location.replace(url);
    }

    useEffect(() => {
        const initPage = async () => {
            switch (props.agentType) {
                case 'capLegacy':
                    setAgentType(capLegacy);
                    break;
                case 'nonCapLegacy':
                    setAgentType(nonCapLegacy);
                    break;
                case 'originLegacy':
                    setAgentType(originLegacy);
                    if (username) {
                        try {
                            const verifiedEncryptedUser = await fetchVerifyUserEncrypt({ username });
                            setEncryptedUserData(verifiedEncryptedUser.data); 
                            if (verifiedEncryptedUser.errorCode && !errorCodesToIgnore.includes(verifiedEncryptedUser.errorCode)) {
                                setIsValid(false);
                                setShowBannerType(verifiedEncryptedUser.errorCode);
                            }
                            setLoading(false);
                        } catch(error) {
                            setIsValid(false);
                            setShowBannerType('E900');
                        }
                    }
                    break;
                case 'newAgent':
                default:
                    setAgentType(newAgent);
            }
            setLoading(false);
        };

        initPage();
    }, [props.agentType, username]);

    if (loading) {
        return <LoadingComponent />;
    }

    const onValidateAgent = () => {
        history.push('/signup?userdata=' + encryptedUserData);
    };

  const continueAction = async (action) => {
    switch (action) {
      case 'Log in':
        window.location.replace(appSettings.AZURE_AD_CLIENT_REDIRECT_URI);
        break;
      default:
        break;
    }
  }

	return (
     <div className="agent-ciam-container">
        <div className="welcome-screen-page">
            <Grid container className="container-styling">
                <Grid size={{ xs: 12, lg: 5 }}>   
                    <ImageComponent  src={logo}/>      		          
                </Grid>
                <Grid size={{ xs: 12, lg: 7 }}> 
                    <div className="welcome-screen-para">
                    <CommonBannerComponent bannerState='inline' bannerType={showBannerType} continueAction={continueAction} />  
                        <div className="eyebrow">{agentType.title}</div>
                        <div className="welcome-header">{agentType.subtitle}</div>
                        <p className="list-styling">{agentType.copy}</p>
                        <div className="welcome-list-header">{agentType.header}</div>

                        {/* Verifica si `agentType.requirements` existe antes de iterar */}
                        { (props.agentType === 'newAgent' || props.agentType === 'originLegacy') && agentType.requirements ? (
                            <div>
                                <ul>
                                    {agentType.requirements.map((req, index) => (
                                        <li className="list-styling" key={index}>{req}</li>
                                    ))}
                                </ul>
                            </div>
                        ) : agentType.requirements ? (
                            <>
                                <div>
                                    {agentType.requirements.map((req, index) => (
                                        <p className="list-styling" key={index}>{req}</p>
                                    ))}
                                </div>
                                <br /><br />
                            </>
                        ) : null }

                        {IdValue === "exnonsso" || IdValue === null ? 
                            <p className="list-styling wel-help-para ">Need help at any point? Click the help icon to the right.</p>    
                            : <p className="list-styling wel-help-para ">Contact your administrator!!</p>                   
                        }
                        
                        {props.agentType === 'newAgent' && (
                            <Button
                                component={RouterLink}
                                className="lets-get-started-button"
                                to={agentType.redirectLink}
                                onClick={props.scrollToTop}
                            >
                                <span>Let’s get started</span>
                            </Button>
                        )}

                        {props.agentType === 'originLegacy' && (
                            <div className="origin-legacy-action">
                                <Button
                                    disableRipple
                                    className="continue-button"
                                    disabled={!isValid}
                                    onClick={onValidateAgent}
                                >
                                    Verify your email address
                                </Button>
                            </div>
                        )}

                        {props.agentType !== 'newAgent' && props.agentType !== 'originLegacy' && (
                            <Button
                                component={RouterLink}
                                className="lets-get-started-button"
                                onClick={() => handleNavigation(agentType.redirectLink)}
                            >
                                <span>Let's get started</span>
                            </Button>
                        )}

                        {props.agentType !== 'originLegacy' && 
                            <div className="existing-account-container">
                                <div>    
                                    <div className="create-account">Already created an AMsuite+ account?</div>
                                    <p>Log in with your new Login ID (Email). To add another username, use the "I want to..." dropdown menu at the top of any page.</p>                 
                                </div>
                                <div>                            
                                    <Link
                                        href={appSettings.AZURE_AD_CLIENT_REDIRECT_URI}                            
                                        className="login-link">
                                            <span  className="login-link-styling">Log in</span>
                                    </Link>
                                </div>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>  
        </div>
     </div>
	);
}

export default WelcomePage;
